import { type Listener } from '@databases/event-bus';

import { type CoreEventBusEvents } from '..';

export type FieldTypesConfigRebuilder = (flags: Record<string, boolean>) => void;
type EventType = CoreEventBusEvents['featureFlagsChanged'];

/**
 * We have a large config for fields here: databases/packages/fields/src/fields.tsx.
 * To avoid memory issues and extra GC, this will maintain an object that only gets rebuilt
 * when these specific, dependent events change.
 */
export const rebuildFieldTypesConfig = (
  rebuilder: FieldTypesConfigRebuilder
): Listener<EventType> => {
  return (event: EventType) => {
    rebuilder(event);
  };
};
